export const GET_COLLEGE_COUNSELLING_SETTINGS = 'GET_COLLEGE_COUNSELLING_SETTINGS'
export const UPDATE_COLLEGE_COUNSELLING_SETTINGS = 'UPDATE_COLLEGE_COUNSELLING_SETTINGS'
